/**
 * Defines an abstract strategy used to determine whether messages (e.g., "Download App") can be displayed.
 */
export abstract class MessageDisplayStrategy {
    abstract canDisplayDownloadAppMessage(): boolean;
}